let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("krV0u")).then(() => parcelRequire('fV6QY'));